
import { Component, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";
import "@/store/modules/forms/form17";
const form17State = namespace("Form17");

import Form17ProcessHeader from "@/components/process/Form17/components/Form17ProcessHeader.vue";
import Spinner from "@/components/utils/Spinner.vue";
import { packageInfoType } from '@/types/Information';
import { form17StatusInfoType } from '@/types/Information/Form17';

@Component({
    components:{
        Form17ProcessHeader,
        Spinner
    }
})
export default class SubmitForm17 extends Vue {

    @form17State.State
    public currentCertificateOfCostsId: string;

    stepsCompleted = {} as form17StatusInfoType;  
    mountedData = false; 
    packageInfo = {} as packageInfoType;
    submitting = false;
    errorMsg=""

    mounted() {
        this.mountedData = false;    
        this.submitting = false;    
        this.errorMsg = ""
        this.stepsCompleted = {
            first: true,
            second: true,
            third: false
        }
        this.mountedData = true;         
    }    

    public submit() {

        this.submitting = true;
        this.errorMsg =""

        const url = "/form17/efiling/"+this.currentCertificateOfCostsId+"/submit/";

        const header = {
            responseType: "json",
            headers: {
                "Content-Type": "application/json",
            }
        }

        this.$http.post(url, header)
        .then(res => {                            
            // this.submitting = false;
            if(res.data?.message=="success" && res.data?.redirectUrl){
                const eFilingUrl = res.data?.redirectUrl
                location.replace(eFilingUrl);
            }else
                this.submitting = false;
        }, err => {
            console.log(err.response?.data?.message);
            const generalError = " Error in submission. Please refresh the page and try again."
            if(err.response?.data?.message)
                this.errorMsg = err.response.data.message
            else if(err.response?.data?.detail)
                this.errorMsg = err.response.data.detail+generalError
            else
                this.errorMsg = generalError
            this.submitting = false;
        });        
    }

    public cancel() {
        this.$router.push({name: "dashboard" }) 
    }
}
